import moment from 'moment';
import React from 'react';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';
import OverviewSyncStatusCard from '../OverviewSyncStatusCard';
import { FileStorageIcon } from '../StatusIcons';

const red = `bg-danger`;
const green = `bg-success`;
const grey = `bg-secondary`;

const InstanceReport = ({ iconSize = '50px' }) => {
    let isReportingOfferingPractice = useSelector((state) => state.practice.practice?.practiceOfferings?.find(x => x.isReportingOffering));
    
    const dispatch = useDispatch();
    
    const latestRuntimeInstanceReport = useSelector(
        (state) => state.practice?.latestRuntimeInstanceReport, shallowEqual);

    const instanceId = useSelector(state => state.practice?.practice?.instanceId);

    useEffect(() => {
        if (instanceId) {
            getLatestTimeInstanceReport(dispatch, instanceId);
        }
    }, [dispatch, instanceId]);
    if(!isReportingOfferingPractice) return [];
    let tileText = 'Runtime not found';

    // if there is an instance ID for the practice but the redux is undefined or does not match, it means the request is still ongoing
    if(instanceId && latestRuntimeInstanceReport.instanceId !== instanceId) {
        tileText = 'Fetching Data'
    }
    let { instanceReportRan } = latestRuntimeInstanceReport;
    let runtimeEmpty = !instanceReportRan?.length;
    let runtimeError = instanceReportRan === 'Runtime not found';
    let tileClass = runtimeEmpty ? grey : runtimeError ? red : green;
    
    if(!runtimeEmpty && !runtimeError) {
        let lastRunTitle = moment(instanceReportRan)
                        .utc()
                        .format('M/D/YYYY LT UTC');

        let lastRunText = moment(instanceReportRan)
                    .local()
                    .format('M/D/YYYY LT');

        tileText = (
            <div className="info-box-content">
                <span
                    className="info-box info-box-number"
                    title={`Last run: ${lastRunTitle}`}>{`Last run: ${lastRunText}`}</span>
            </div>
        );            
    }
    return (
        <OverviewSyncStatusCard
            classes={tileClass}
            icon={<FileStorageIcon size={iconSize} fill="#fff" />}
            heading="Instance Report"
            text={tileText}
        />
    );
}

const getLatestTimeInstanceReport = async (dispatch, practiceId) => {
    return dispatch(
        actions.practice.getLatestInstanceReportRuntime(practiceId)
    );
};

export default InstanceReport;
